<template>
  <v-main>
    <v-container>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n4">Editar Cliente</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <v-row>
          <v-col md="8">
            <v-text-field
              label="Nome"
              v-model="fields.name.value"
              :rules="[...fields.name.rules, ...fields.name.apiErrors]"
              type="text"
              @input="fields.name.apiErrors = []"
              outlined dense
            ></v-text-field>
          </v-col>
          <v-col md="4">
            <v-text-field
              label="Apelido"
              v-model="fields.nickname.value"
              :rules="[...fields.nickname.rules, ...fields.nickname.apiErrors]"
              type="text"
              @input="fields.nickname.apiErrors = []"
              outlined dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <v-text-field
              label="Documento pessoal"
              v-model="fields.person_document.value"
              :rules="[...fields.person_document.rules, ...fields.person_document.apiErrors]"
              @input="fields.person_document.apiErrors = []"
              v-mask="fields.person_document.mask"
              outlined dense
              :loading="checking"
              @blur="checkCustomer('person_document', fields.person_document.value)"
            ></v-text-field>
          </v-col>
          <v-col v-if="!id" md="4">
            <v-text-field
              label="Telefone"
              v-model="fields.phone.value"
              :rules="[...fields.phone.rules, ...fields.phone.apiErrors]"
              type="text"
              @input="fields.phone.apiErrors = []"
              v-mask="'(##) # ####-####'"
              :loading="checking"
              @blur="checkCustomer('phone', fields.phone.value)"
              outlined dense
            ></v-text-field>
          </v-col>
          <v-col md="4">
            <v-text-field
              label="E-mail"
              v-model="fields.email.value"
              :rules="[...fields.email.rules, ...fields.email.apiErrors]"
              type="text"
              @input="fields.email.apiErrors = []"
              outlined dense
            ></v-text-field>
          </v-col>
          <v-col v-if="id" md="4">
            <div style="margin-top: -8px;">
              <small>Telefone</small>
              <br>
              <b>{{ fields.phone.value | phone_number }}</b>
            </div>
          </v-col>
        </v-row>
        <span class="subtitle-1">Endereço</span>
        <v-checkbox v-if="!id" v-model="addAddress" :label="`Tem informações de endereço?`" />
        <template v-if="id || addAddress">
          <v-row>
            <v-col md="6">
              <v-text-field
                label="Rua"
                v-model="fields.address.value.street"
                :rules="[]"
                type="text"
                @input="fields.address.apiErrors = []"
                outlined dense
              ></v-text-field>
            </v-col>
            <v-col md="3">
              <v-text-field
                label="Número"
                v-model="fields.address.value.number"
                :rules="[]"
                type="number"
                @input="fields.address.apiErrors = []"
                outlined dense
              ></v-text-field>
            </v-col>
            <v-col md="3">
              <v-text-field
                label="Complemento"
                v-model="fields.address.value.complement"
                :rules="[]"
                type="text"
                @input="fields.address.apiErrors = []"
                outlined dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="3">
              <v-text-field
                label="CEP"
                v-model="fields.address.value.postal_code"
                v-mask="'#####-###'"
                :rules="[]"
                type="text"
                @input="fields.address.apiErrors = []"
                outlined dense
              ></v-text-field>
            </v-col>
            <v-col md="3">
              <v-text-field
                label="Bairro"
                v-model="fields.address.value.neighborhood"
                :rules="[]"
                type="text"
                @input="fields.address.apiErrors = []"
                outlined dense
              ></v-text-field>
            </v-col>
            <v-col md="3">
              <v-text-field
                label="Cidade"
                v-model="fields.address.value.city"
                :rules="[]"
                type="text"
                @input="fields.address.apiErrors = []"
                outlined dense
              ></v-text-field>
            </v-col>
            <v-col md="3">
              <v-select
                label="Estado"
                :items="fields.address.states"
                v-model="fields.address.value.state"
                type="text"
                @input="fields.address.apiErrors = []"
                outlined dense
              ></v-select>
            </v-col>
          </v-row>
        </template>
        <v-btn color="success" :disabled="sending || checking" :loading="sending" @click="send()">Salvar</v-btn>
        <v-btn text color="error" :disabled="sending" @click="$router.go(-1)">Cancelar</v-btn>
      </v-form>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mask } from 'vue-the-mask'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'

export default {
  name: 'customerForm',
  directives: {
    mask
  },
  components: {
    AppLoading
  },
  props: ['id'],
  data () {
    return {
      loading: false,
      sending: false,
      checking: false,
      errorMessage: '',
      fields: {
        name: {
          value: '',
          rules: [v => !!v || 'É obrigatório', v => (!!v && v.split(' ').length > 1) || 'Precisa ter pelo menos 2 nomes'],
          apiErrors: []
        },
        nickname: {
          value: '',
          rules: [v => !!v || 'É obrigatório'],
          apiErrors: []
        },
        birthdate: {
          value: '',
          rules: [],
          apiErrors: []
        },
        person_document: {
          value: '',
          mask: '###.###.###-##',
          rules: [v => !!v || 'É obrigatório', v => this.checkDocument(v) || 'Não é um documento válido'],
          apiErrors: []
        },
        phone: {
          value: '',
          mask: '(##) # ####-####',
          rules: [v => !!v || 'É obrigatório'],
          apiErrors: []
        },
        email: {
          value: '',
          rules: [v => !!v || 'É obrigatório'],
          apiErrors: []
        },
        address: {
          value: {},
          rules: {},
          apiErrors: [],
          states: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO']
        }
      },
      addAddress: false
    }
  },
  created () {
    if (this.id) {
      this.loading = true
      axios.get('customers/' + this.id)
        .then(({ data }) => {
          for (let key in this.fields) {
            if (data[key]) this.fields[key].value = data[key]
          }
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          this.$router.push({ name: 'customers' })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (key === 'person_document' && this.fields[key].value) {
          data['person_type'] = this.fields[key].value.length > 14 ? 'PJ' : 'PF'
          data[key] = this.fields[key].value.replace(/\./g, '').replace(/-/, '')
        } else if (key === 'address') {
          if (this.addAddress) data[key] = this.fields[key].value
        } else if (key === 'phone') {
          if (this.fields.phone.value && !this.id) data[key] = this.fields[key].value.replace(/\(/g, '').replace(/\)/g, '').replace(/-/, '').replace(' ', '').replace(' ', '')
        } else if (key === 'email' && this.fields[key].value) {
          data[key] = this.fields[key].value.trim().toLowerCase()
        } else if (this.fields[key].value) {
          data[key] = this.fields[key].value
        }
      }
      if (!this.id && !this.addAddress) {
        data.address = {
          street: 'Av. Gov. Agamenon Magalhães',
          number: '2939',
          complement: 'Sala 406',
          postal_code: '52021-220',
          neighborhood: 'Espinheiro',
          city: 'Recife',
          state: 'PE'
        }
      }
      return data
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    checkCustomer (type, value) {
      if (value) {
        this.checking = true
        const cleanedValue = value.replace(/\./g, '').replace(/-/, '').replace(/\(/g, '').replace(/\)/g, '').replace(/-/, '').replace(' ', '').replace(' ', '')
        axios.get(`customers?filter[q]=${cleanedValue}`)
          .then(({ data }) => {
            const items = data.data
            if (items && items.length > 0) {
              for (const index in items) {
                if (!this.id || items[index].id !== this.id) {
                  this.fields[type].apiErrors.push('Já existe um cliente cadastrado')
                }
              }
            }
          })
          .finally(() => {
            this.checking = false
          })
      }
    },
    checkDocument (val) {
      if (val.length === 14) {
        var cpf = val.trim()
        cpf = cpf.replace(/\./g, '').replace('-', '').split('')

        let v1 = 0
        let v2 = 0
        let aux = false

        for (let i = 1; cpf.length > i; i++) if (cpf[i - 1] !== cpf[i]) aux = true
        if (!aux) return false

        console.log('aqui')

        for (let i = 0, p = 10; (cpf.length - 2) > i; i++, p--) v1 += cpf[i] * p
        console.log(v1)
        v1 = ((v1 * 10) % 11)
        console.log(v1)
        if (v1 === 10) v1 = 0
        console.log(v1, parseInt(cpf[9]))
        if (v1 !== parseInt(cpf[9])) return false

        console.log('aqui2')

        for (let i = 0, p = 11; (cpf.length - 1) > i; i++, p--) v2 += cpf[i] * p
        v2 = ((v2 * 10) % 11)
        if (v2 === 10) v2 = 0
        if (v2 !== parseInt(cpf[10])) return false

        console.log('aqui3')

        return true
      } else if (val.length === 18) {
        let cnpj = val.trim()
        cnpj = cnpj.replace(/\./g, '').replace('-', '').replace('/', '').split('')

        let v1 = 0
        let v2 = 0
        let aux = false

        for (let i = 1; cnpj.length > i; i++) if (cnpj[i - 1] != cnpj[i]) aux = true
        if (!aux) return false

        for (var i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
          if (p1 >= 2) v1 += cnpj[i] * p1
          else v1 += cnpj[i] * p2
        }
        v1 = (v1 % 11)
        if (v1 < 2) v1 = 0
        else v1 = (11 - v1)
        if (v1 !== parseInt(cnpj[12])) return false

        for (let i = 0, p1 = 6, p2 = 14; (cnpj.length - 1) > i; i++, p1--, p2--) {
          if (p1 >= 2) v2 += cnpj[i] * p1
          else v2 += cnpj[i] * p2
        }
        v2 = (v2 % 11)
        if (v2 < 2) v2 = 0
        else v2 = (11 - v2)
        if (v2 !== parseInt(cnpj[13])) return false

        return true
      } else {
        return false
      }
    },
    send () {
      if (this.$refs.form.validate()) {
        this.sending = true
        this.errorMessage = null
        const url = (this.id) ? 'customers/' + this.id : 'customers'
        const method = (this.id) ? 'patch' : 'post'

        axios(url, {
          method,
          data: this.apiData
        })
          .then(response => {
            if (response) {
              console.log(response.data)
              this.SET_SNACKBAR({ text: (this.id) ? 'Cliente atualizado' : 'Cliente adicionado' })
              this.$router.push({ name: 'customerDetails', params: { id: response.data.id } })
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              if (error.response.data) this.generateApiErrors(error.response.data)
              this.errorMessage = 'Verifique os campos com erro'
            } else {
              this.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
            }
          })
          .finally(() => {
            this.sending = false
          })
      } else {
        this.errorMessage = 'Verifique os campos com erro'
      }
    }
  }
}
</script>
